import React from 'react'
import './styles.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import { browserCheck } from '@ta-interaktiv/browsercheck'

const isTablet = browserCheck.isTablet
const isMobile = browserCheck.isMobile
const isSmallScreen = window.innerWidth < 1100 && window.innerWidth > 900

function Dashboard(props) {
  return (
    <>
      <h3 className='graphTitle'>
        Auf diesem Klimakurs befinden sich die Staaten
      </h3>
      <div className='subtitle'>
        Der Climate Action Tracker (CAT) berücksichtigt Daten von 32 Staaten,
        die zusammen für etwa 80% der globalen Emissionen verantwortlich sind.
      </div>
      <div className='ui grid centered' id='dashboard'>
        <div
          className={
            'unstackable ' +
            (isMobile
              ? 'two'
              : isTablet
              ? 'three'
              : isSmallScreen
              ? 'four'
              : 'six') +
            ' column row countries'
          }
        >
          <div className='column space'>
            <table className='ui small table compact unstackable'>
              <thead>
                <tr>
                  <th>
                    <div className='ui horizontal label violet'>
                      <div className='white'>+4°C</div>
                    </div>
                    <div className='violet'>Kritisch ungenügend</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Argentinien</td>
                </tr>
                <tr>
                  <td>Russland</td>
                </tr>
                <tr>
                  <td>Saudiarabien</td>
                </tr>
                <tr>
                  <td>Singapur</td>
                </tr>
                <tr>
                  <td>Türkei</td>
                </tr>
                <tr>
                  <td>Ukraine</td>
                </tr>

                <tr>
                  <td>Vietnam</td>
                </tr>
                <tr />
              </tbody>
            </table>
          </div>

          <div className='column space'>
            <table className='ui small table compact unstackable'>
              <thead>
                <tr>
                  <th>
                    <div className='ui horizontal label red'>
                      <div className='white'>+3-4°C</div>
                    </div>
                    <div className='red'>Stark ungenügend</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {' '}
                <tr>
                  <td>Brasilien</td>
                </tr>
                <tr>
                  <td>China</td>
                </tr>
                <tr>
                  <td>Indonesien</td>
                </tr>
                <tr>
                  <td>Südkorea</td>
                </tr>
                <tr>
                  <td>Vereinigte Arabische Emirate</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className='column space'>
            <table className='ui small table compact unstackable'>
              <thead>
                <tr>
                  <th>
                    <div className='ui horizontal label orange'>
                      <div className=''>+2-3°C</div>
                    </div>
                    <div className='orange'>Ungenügend</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Australien</td>
                </tr>
                <tr>
                  <td>Chile</td>
                </tr>{' '}
                <tr>
                  <td>Deutschland</td>
                </tr>
                <tr>
                  <td>Europa</td>
                </tr>{' '}
                <tr>
                  <td>Indien</td>
                </tr>{' '}
                <tr>
                  <td>Japan</td>
                </tr>
                <tr>
                  <td>Kanada</td>
                </tr>
                <tr>
                  <td>Kasachstan</td>
                </tr>
                <tr>
                  <td>Mexiko</td>
                </tr>
                <tr>
                  <td>Neuseeland</td>
                </tr>
                <tr>
                  <td>Norwegen</td>
                </tr>
                <tr>
                  <td>Peru</td>
                </tr>
                <tr>
                  <td>Schweiz</td>
                </tr>
                <tr>
                  <td>Südafrika</td>
                </tr>{' '}
                <tr>
                  <td>USA</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className='column space'>
            <table className='ui small table compact unstackable'>
              <thead>
                <tr>
                  <th>
                    <div className='ui horizontal label yellow'>
                      <div>+1.5-2°C</div>
                    </div>
                    <div className='yellow'>2-Grad-Welt</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Äthiopien</td>
                </tr>
                <tr>
                  <td>Buthan</td>
                </tr>
                <tr>
                  <td>Costa Rica</td>
                </tr>
                <tr>
                  <td>Marokko</td>
                </tr>
                <tr>
                  <td>Kenia</td>
                </tr>
                <tr>
                  <td>Philippinen</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className='column space'>
            <table className='ui small table compact unstackable'>
              <thead>
                <tr>
                  <th>
                    <div className='ui horizontal label green'>
                      <div>+1.5°C</div>
                    </div>
                    <div className='green'>1.5-Grad Welt (Paris)</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Gambia</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className='column space'>
            <table className='ui small table compact unstackable'>
              <thead>
                <tr>
                  <th>Vorbilder</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>–</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}
export { Dashboard }
